import { AxiosError } from "axios";

/** glen's NoRoute answer: what every Top 10 route says while switched off. */
const SWITCHED_OFF_ERROR_CODE = 1035;

/** Backend error codes of the Top 10 routes (`common/errors/errors.go`). */
export const TOP_TEN_ERROR_CODES = {
  FULL: 1305,
  NOT_ALLOWED: 1306,
} as const;

const readErrorCode = (error: unknown): number | undefined => {
  const code = (error as AxiosError<{ error_code?: number }>)?.response?.data
    ?.error_code;

  return typeof code === "number" ? code : undefined;
};

/** The switch is off (or the route isn't deployed yet): an answer, not an error. */
export const isTopTenSwitchedOff = (error: unknown): boolean =>
  (error as AxiosError)?.response?.status === 404 &&
  readErrorCode(error) === SWITCHED_OFF_ERROR_CODE;

/** A Top 10 refusal in plain words, keyed on the backend's error_code. */
export const describeTopTenFailure = (
  error: unknown,
  fallback: string
): string => {
  switch (readErrorCode(error)) {
    case TOP_TEN_ERROR_CODES.FULL:
      return "Your Top 10 is full. Remove one first.";
    case TOP_TEN_ERROR_CODES.NOT_ALLOWED:
      return "Only your own nurtures and cold leads can go in your Top 10.";
  }

  return fallback;
};
